import dayjs from "dayjs";
import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import axiosClient from "../Services/Axios/axios";
import CommanPagination from "./common/CommanPagination/CommanPagination";
import ProfileSidebar from "./common/ProfileSidebar";
import DateFormatter from "./common/DateFormatter/DateFormatter";
const MonthData = [
  {
    value: 1,
    label: "January",
  },
  {
    value: 2,
    label: "February",
  },
  {
    value: 3,
    label: "March",
  },
  {
    value: 4,
    label: "April",
  },
  {
    value: 5,
    label: "May",
  },
  {
    value: 6,
    label: "June",
  },
  {
    value: 7,
    label: "July",
  },
  {
    value: 8,
    label: "August",
  },
  {
    value: 9,
    label: "September",
  },
  {
    value: 10,
    label: "October",
  },
  {
    value: 11,
    label: "November",
  },
  {
    value: 12,
    label: "December",
  },
];
const MyEarning = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [donationCountData, setDonationCountData] = useState();
  const [donationData, setDonationData] = useState();
  const [campaigns, setCampaigns] = useState([]);
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [filter, setFilter] = useState("");
  const getAllDonationData = async () => {
    try {
      setLoading(true);
      const response = await axiosClient.get(`users/getDashboard?language=en`);
      if (!response.data.error) {
        setDonationCountData(response.data.data);
      } else {
        setDonationCountData({});
      }

      const response1 = await axiosClient.get(
        `users/getMyEarnDonationListing?language=en&pageSize=${limit}&pageNo=${currentPage}&month=${month}&year=${year}&campaign=${filter}`
      );
      if (!response1.data.error) {
        setLoading(false);
        setDonationData(response1.data);
      } else {
        setDonationData({});
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      setDonationCountData([]);
    }
  };
  const getCampaignData = async () => {
    try {
      const response1 = await axiosClient.get(
        "campaigns/getMyAcitveCampaigns?language=en&pageSize=100&pageNo=1"
      );
      if (!response1.data.error && Array.isArray(response1.data.data.rows)) {
        setCampaigns(response1.data.data.rows);
      } else {
        setCampaigns([]);
      }
    } catch (error) {
      console.log(error);
      setCampaigns([]);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllDonationData();
    getCampaignData();
  }, [currentPage, limit, month, filter, year]);
  return (
    <>
      <div className="all_suport_bg manages_top">
        <section className="ser_v_araeea profiles">
          <div className="container">
            <div className="bradcams">
              <span className="bothss">
                <Link to="">My Account</Link>{" "}
                <img src="/images/brd_rowwo.png" alt="" /> MyEarning
              </span>
            </div>
            <div className="row">
              <div className="col-lg-3 mb_view_hide">
                <ProfileSidebar />
              </div>
              <div className="col-lg-9">
                <div className="form_boxx Impact">
                  <div className="row">
                    <div className="col-lg-12 col-sm-6">
                      <div className="im_pects_box">
                        <div className="ic_arae">
                          <img src="/images/wallet_s_im.png" alt="" />
                        </div>
                        <div className="im_tc_texs">
                          <p>Total Earning Amount</p>
                          <h6>
                            {donationCountData?.myEarning
                              ? donationCountData?.myEarning
                              : 0}{" "}
                            USD
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="row mb_spacess mt-4">
                    <div className="col-lg-6">
                      <div className="Imepctgrp">
                        <div className="top_cnt_impct">
                          <div className="titals_im">Volunteering Report</div>
                          <div className="monthly_impct">
                            <select>
                              <option value="">Monthly</option>
                            </select>
                          </div>
                          <div className="don_impacts">
                            <div className="down">
                              <img src="/images/download_ic.png" alt="" />
                            </div>
                            <div className="down">
                              <img src="/images/three_do_ic.png" alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="Imepctgrp">
                        <div className="top_cnt_impct">
                          <div className="titals_im">Donations</div>
                          <div className="monthly_impct">
                            <select>
                              <option value="">Monthly</option>
                            </select>
                          </div>
                          <div className="don_impacts">
                            <div className="down">
                              <img src="/images/download_ic.png" alt="" />
                            </div>
                            <div className="down">
                              <img src="/images/three_do_ic.png" alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {loading ? (
                    <div className="member-loader">
                      <BeatLoader color="#097C81" />
                    </div>
                  ) : (
                    <>
                      {" "}
                      <div className="row mb_spacess mt-4">
                        <div className="col-lg-12">
                          <div className="Imepctgrp tabless">
                            <div className="top_cnt_impct">
                              <div className="titals_im">My Earning</div>
                              <div
                                className="monthly_impct"
                                style={{ width: "50%" }}
                              >
                                <select
                                  id="campaign_select"
                                  value={filter}
                                  onChange={(e) => setFilter(e.target.value)}
                                >
                                  <option value="" disabled>
                                    Select Campaign
                                  </option>

                                  {Array.isArray(campaigns) &&
                                    campaigns.map((campaign) => (
                                      <option
                                        key={campaign.id}
                                        value={campaign.id}
                                      >
                                        {campaign.donation_title}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              <div
                                className="monthly_impct"
                                style={{ width: "35%" }}
                              >
                                <select
                                  id="mnth_slt"
                                  value={year}
                                  onChange={(e) => setYear(e.target.value)}
                                >
                                  <option value="" disabled>
                                    Sort Year
                                  </option>
                                  <option value={2025}>2025</option>
                                  <option value={2026}>2026</option>
                                  <option value={2027}>2027</option>
                                  <option value={2028}>2028</option>
                                  <option value={2029}>2029</option>
                                  <option value={2030}>2030</option>
                                </select>
                              </div>
                              <div
                                className="monthly_impct"
                                style={{ width: "50%" }}
                              >
                                <select
                                  value={month}
                                  onChange={(e) => setMonth(e.target.value)}
                                >
                                  <option value="" disabled>
                                    Select a month
                                  </option>
                                  {MonthData &&
                                    MonthData.map((item) => (
                                      <option
                                        key={item.value}
                                        value={item.value}
                                      >
                                        {item.label}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              {/* <div className="don_impacts">
                                <div className="down">
                                  <Link to="">View More</Link>
                                </div>
                              </div> */}
                            </div>

                            <div class="table-responsive mt-2">
                              <table class="table table-striped al_suport_items mb-0">
                                <thead>
                                  <tr>
                                    <th>Sr. No</th>
                                    <th>Transaction ID</th>
                                    <th>Campaign</th>
                                    <th>Date</th>
                                    <th>Amount</th>
                                    <th>Commission (%)</th>
                                    <th>Commission Amount</th>
                                    <th>My Earning</th>
                                    <th>Status</th>
                                    <th>Payment Type</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {donationData &&
                                    donationData?.data?.rows?.map((item, i) => {
                                      return (
                                        <tr key={i}>
                                          <td>
                                            {(currentPage - 1) * limit + i + 1}
                                          </td>
                                          <td> {item.transactionId}</td>
                                          <td>
                                            {item.campaign.donation_title}
                                          </td>
                                          <td>
                                            {DateFormatter(item.created_at)}
                                          </td>
                                          <td>{item.amount} USD</td>
                                          <td>{item.commission_percentage}%</td>
                                          <td>{item.commission_amount}</td>
                                          <td>
                                            {item.amount -
                                              item.commission_amount}
                                          </td>
                                          <td>
                                            {/* {item.status === 0 ? "Pending" : 
                                            item.status === 1 ? "Active" : 
                                            item.status === 2 ? "Rejected" : 
                                            "Unknown Status"} */}

                                            <span
                                              className={
                                                item.status === 0
                                                  ? "text-orange"
                                                  : item.status === 1
                                                  ? "text-success"
                                                  : item.status === 2
                                                  ? "text-red"
                                                  : "text-gray"
                                              }
                                            >
                                              {item.status === 0
                                                ? "Pending"
                                                : item.status === 1
                                                ? "Active"
                                                : item.status === 2
                                                ? "Rejected"
                                                : "Unknown Status"}
                                            </span>
                                          </td>

                                          <td>
                                            {item.payment_method_type.toUpperCase()}
                                          </td>

                                          {/* <td className="green_tx_w">
                                            {item.merit_points}
                                          </td> */}
                                          {/* <td className="goldan_tx_w flexx">
                                            5{" "}
                                            <img
                                              src="/images/star_gld.png"
                                              alt=""
                                            />
                                          </td> */}
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </div>
                            <CommanPagination
                              currentPage={currentPage}
                              setCurrentPage={setCurrentPage}
                              limit={limit}
                              setLimit={setLimit}
                              totalCounts={donationData?.data?.totalElement}
                              totalPage={donationData?.data?.totalPage}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {/* <div className="row mb_spacess mt-4">
                    <div className="col-lg-12">
                      <div className="Imepctgrp tabless">
                        <div className="top_cnt_impct two_partss">
                          <div className="titals_im">Participation</div>

                          <div className="don_impacts">
                            <div className="down">
                              <Link to="">View More</Link>
                            </div>
                          </div>
                        </div>

                        <div class="table-responsive mt-2">
                          <table class="table table-striped al_suport_items mb-0">
                            <thead>
                              <tr>
                                <th>Sr. No.</th>
                                <th>Event / Campaign</th>
                                <th>Date</th>
                                <th>Check In</th>
                                <th>Check Out</th>
                                <th>Hours</th>
                                <th>Merits</th>
                                <th className="last">Rating</th>
                              </tr>
                            </thead>
                            <tbody>
                                                     {donationData &&
                                donationData?.data?.rows?.map((item, i) => {
                                  return (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td>Chizen Lee</td>
                                      <td>{item.campaign.donation_title}</td>
                                      <td>Aug, 28 2024 02:28:22 PM </td>
                                      <td>{item.final_amount} USD</td>
                                      <td className="green_tx_w">
                                        {item.merit_points}
                                      </td>
                                      <td className="goldan_tx_w flexx">
                                        5{" "}
                                        <img
                                          src="/images/star_gld.png"
                                          alt=""
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                         <CommanPagination
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                          limit={limit}
                          setLimit={setLimit}
                          totalCounts={donationData?.data?.totalElement}
                          totalPage={donationData?.data?.totalPage}
                        />
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MyEarning;
